import $ from "jquery";
import axios from 'axios';

export default class Form {
    constructor() {
        let removeEmptyValue = (el) => {
            el.classList.remove('filled');
            el.value = '';
        }

        $('.form input, .form textarea').each((i, e) => {
            let current = e;
            let value = current.value;
            value.trim().length > 0 ? current.classList.add('filled') : removeEmptyValue(current);
        });

        $('.form input, .form textarea').blur((e) => {
            let current = e.currentTarget;
            let value = current.value;
            value.trim().length > 0 ? current.classList.add('filled') : removeEmptyValue(current);
        });

        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('input[name="_token"]').val()}
        });

        $('[data-validate]').click((e) => {
            let section = e.currentTarget.dataset.validate;
            let values = 0;
            let fields = Array.from(document.querySelectorAll('.section-' + section + ' input'));
            fields.map(i => {
                !!i.value && values++;
            });
            if (values <= 1) {
                $('.section-' + section).addClass('has-error');
            } else {
                $('.section-' + section).removeClass('has-error');
                window.dispatchEvent(new CustomEvent('goto', {detail: {step: 4}}))
            }
        });


        let form = document.getElementById('meinrocketjob');

        form.addEventListener('submit', e => {
            e.preventDefault();
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.post(form.action, new FormData(form))
                .then(response => {
                    form.reset();
                    $('body').append('<meta http-equiv="refresh" content="15; URL=/">');
                    console.log(response.data)
                window.dispatchEvent(new CustomEvent('goto', {detail: {step: 5}}))
                }).catch(error => {
                console.log(error);
            });
        });
    }
}
